import MeteoHome, { getServerSideProps } from './[locality]';

export default MeteoHome;

export { getServerSideProps };
